/**
 * Generates an RFC 4122 v4 identifier without depending on crypto.randomUUID().
 * randomUUID is unavailable in some PWA/WebView/insecure HTTP contexts.
 */
export function createUuid(): string {
  const cryptoApi = typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    try { return cryptoApi.randomUUID(); } catch { /* fallback below */ }
  }

  const bytes = new Uint8Array(16);
  let filled = false;
  if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
    try { cryptoApi.getRandomValues(bytes); filled = true; } catch { /* fallback below */ }
  }
  if (!filled) {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
}
